import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://fggtrmmxfetarsuoyair.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZnZ3RybW14ZmV0YXJzdW95YWlyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMxOTIyNzgsImV4cCI6MjA4ODc2ODI3OH0.WX9zPlx6NSgt5H4RQ2-xLqzjG-nMZCEtJ6w4XyQV2d8';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
